import { useGetIdentity, useLogout } from '@refinedev/core';
import { Layout, Space, Avatar, Dropdown, Typography } from 'antd';
import type { MenuProps } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface User {
  id: number;
  fullName?: string;
  username: string;
  avatar?: string;
}

export const Header = () => {
  const { data: user } = useGetIdentity<User>();
  const { mutate: logout } = useLogout();

  const menuItems: MenuProps['items'] = [
    {
      key: 'logout',
      label: 'Chiqish',
      icon: <LogoutOutlined />,
      danger: true,
      onClick: () => logout(),
    },
  ];

  return (
    <Layout.Header
      style={{
        background: '#fff',
        padding: '0 24px',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        borderBottom: '1px solid #E8E8E8',
      }}
    >
      <Dropdown menu={{ items: menuItems }} trigger={['click']}>
        <Space style={{ cursor: 'pointer' }}>
          <Avatar
            size="small"
            icon={<UserOutlined />}
            src={user?.avatar}
            style={{ backgroundColor: '#1ABC9C' }}
          />
          <Text strong>{user?.fullName || user?.username || 'Admin'}</Text>
        </Space>
      </Dropdown>
    </Layout.Header>
  );
};
